import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { ERegistrars } from '@feathr/blackbox';
import Page from '@feathr/extender/App/Page';
import { useStore } from '@feathr/extender/state';

import { useDomainStatusPolling } from './DomainDetailPage.hooks';
import DomainInfoCard from './DomainInfoCard';
import DomainOverviewCard from './DomainOverviewCard';
import DomainRecordsCard from './DomainRecordsCard';

import * as styles from './DomainDetailPage.css';

function DomainDetailPage(): JSX.Element {
  const { t } = useTranslation();
  const { Domains } = useStore();
  const { domainId } = useParams<{ domainId: string }>();
  if (!domainId) {
    throw new Error(t('Domain id not found.'));
  }
  const domain = Domains.get(domainId);
  useDomainStatusPolling(domain);

  return (
    <Page loading={domain.isPending} title={domain.displayDomain}>
      <div className={styles.cards}>
        <DomainOverviewCard domain={domain} />
        <DomainInfoCard domain={domain} />
        <DomainRecordsCard domain={domain} format={ERegistrars.default} />
      </div>
    </Page>
  );
}

export default observer(DomainDetailPage);
